<template>
  <div class="home flexBox" v-if="isAll">
    <van-nav-bar
      class="flexNone"
      :title="$t('Dishes.title')"
      left-arrow
      fixed
      @click-left="
        $router.push(
          '/Home/' + sessionStorage.storeId + '/book/' + sessionStorage.code
        )
      "
    >
    </van-nav-bar>
    <div class="contentWrapper">
      <div
        v-if="dishes"
        :class="[
          sessionStorage.orderType == 'add' ? 'menuContent1' : 'menuContent'
        ]"
      >
        <van-sidebar v-model="activeKey" @change="changeKey()">
          <template v-for="(dish, index) in dishes">
            <van-sidebar-item :title="dish.name"></van-sidebar-item>
          </template>
        </van-sidebar>
        <div class="dishContent">
          <template v-if="actMenus.length > 0">
            <div
              v-for="(menu, index) in actMenus"
              class="dishItem"
              @click.stop="
                menu.category == 'm'
                  ? $router.push('/E_DishDetail/' + menu.id)
                  : $router.push('/E_PackageDetail/' + menu.id)
              "
            >
              <template v-if="menu.image">
                <van-image
                  class="noflex"
                  width="90px"
                  height="90px"
                  style="margin-top: 5px;margin-left: 5px;"
                  fit="contain"
                  :src="menu.image.path"
                />
              </template>
              <template v-else>
                <van-image
                  class="noflex"
                  width="90px"
                  height="90px"
                  style="margin-top: 5px;margin-left: 5px;"
                  fit="contain"
                  src=""
                />
              </template>
              <div class="itemInfo">
                <div class="leftInfo">
                  <div class="fontLine noExceed">{{ menu.name }}</div>
                  <div class="fontLine noExceed">{{ menu.name_en }}</div>
                  <div class="fontLine noExceed">
                    <span class="currentPrice"
                      >{{ sessionStorage.getItem("currency")
                      }}{{
                        menu.type == "o"
                          ? menu.original_price
                          : menu.special_price
                      }}</span
                    >&nbsp;&nbsp;&nbsp;<span
                      class="oldPrice"
                      v-show="menu.type == 's'"
                      >{{ sessionStorage.getItem("currency")
                      }}{{ menu.original_price }}</span
                    >
                  </div>
                  <van-rate
                    style="height: 16px;"
                    readonly
                    v-model="menu.level"
                    :size="16"
                    gutter="3px"
                    icon="./static/img/Recommend-s.png"
                    void-icon="./static/img/Recommend.png"
                  />
                </div>
                <div class="enterIcon">
                  <van-icon name="./static/img/View_orders.png" size="20px" />
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div style="text-align: center;line-height: 80px;">
              {{ $t("Dishes.nonefood") }}
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      level: 5,
      activeKey: 0,
      isShopCartShow: false,
      dishes: [],
      actMenus: [],
      shopCart: {},
      packages: {},
      count: 4,
      isAll: false
    };
  },
  mounted: function() {
    this.getDishes();
  },
  methods: {
    getDishes() {
      // 获取
      this.$axios({
        method: "get",
        headers: {
          type: sessionStorage.type,
          code: sessionStorage.code,
          placeid: sessionStorage.placeId
        },
        url:
          this.$build +
          "/api/store/" +
          sessionStorage.storeId +
          "/customerMenus/in"
      })
        .then(res => {
          // console.log(res);
          if (res.data.status == 200) {
            this.dishes = res.data.data;
            // this.getPackages();
            this.actMenus = this.dishes[this.activeKey].menus;
            this.isAll = true;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                duration: 1000,
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            duration: 1000,
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    getPackages() {
      // 获取
      this.$axios({
        method: "get",
        headers: {
          type: sessionStorage.type,
          code: sessionStorage.code,
          placeid: sessionStorage.placeId
        },
        url:
          this.$build +
          "/api/store/" +
          sessionStorage.storeId +
          "/customerPackages/in"
      })
        .then(res => {
          // console.log(res);
          if (res.data.status == 200) {
            this.packages = res.data.data;
            var packages = {};
            packages.name = this.$t("Dishes.package");
            packages.menus = res.data.data;
            this.dishes = this.prepend(this.dishes, packages);
            this.actMenus = this.dishes[this.activeKey].menus;
            this.isAll = true;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                duration: 1000,
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            duration: 1000,
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    changeKey() {
      sessionStorage.setItem("activeKey", this.activeKey);
      this.actMenus = this.dishes[this.activeKey].menus;
    }
  }
};
</script>
<style scoped>
/deep/ .van-nav-bar .van-icon {
  font-size: 26px;
  color: #fff;
}
/deep/ .van-sidebar {
  width: 30%;
  height: 100%;
  background-color: #fff;
  float: left;
  overflow: auto;
}
/deep/ .van-sidebar-item {
  text-align: center;
  padding: 15px 12px 15px 8px;
  background-color: #fff;
  border-bottom: 1px solid #eee;
}
/deep/ .van-sidebar-item--select {
  color: #fff;
  border-color: #000;
  background-color: #000;
}
/deep/ .van-divider {
  border-width: 2px;
}

.van-button__text {
  color: #fff;
}
.contentWrapper {
  padding-top: 46px;
}
.home {
  width: 100%;
  background-color: #f3f3f3;
}
.menuContent {
  width: 100%;
  height: calc(100vh - 96px);
  flex: auto;
  margin-bottom: 55px;
}
.menuContent1 {
  width: 100%;
  height: calc(100vh - 132px);
  flex: auto;
  margin-bottom: 100px;
}
.dishContent {
  width: 70%;
  height: 100%;
  float: right;
  overflow: auto;
}
.dishItem {
  width: calc(100% - 20px);
  margin: 10px;
  height: 100px;
  background-color: #fff;
  border-radius: 5px;
  position: relative;
  display: flex;
  overflow: hidden;
}
.itemInfo {
  flex: auto;
  display: -webkit-flex; /* Safari */
  display: flex;
  flex-direction: column;
  width: 100px;
}
.leftInfo {
  margin-left: 10px;
  margin-top: 10px;
  min-width: 80%;
  min-height: 5rem;
  font-size: 14px;
}
.fontLine {
  height: 20px;
  overflow: hidden;
  word-break: break-all;
}
.icons {
  display: flex;
  /*width: 80px;*/
  position: absolute;
  bottom: -2px;
  right: 5px;
}
.itemIcon {
  text-align: right;
}
.enterIcon {
  position: absolute;
  top: 10px;
  right: 10px;
}
.flexBox {
  display: -webkit-flex; /* Safari */
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.flexNone {
  flex: none;
}
.currentPrice {
  color: #ff6666;
}
.oldPrice {
  color: #bcbcbc;
  text-decoration: line-through;
}
.cart_left {
  width: 60%;
  height: 34px;
  line-height: 34px;
  float: left;
}
.cart_right {
  width: 40%;
  height: 34px;
  line-height: 34px;
  float: right;
  text-align: right;
}
.cart_right_btn {
  height: 34px;
  line-height: 34px;
  font-size: 16px;
  color: #222;
}
.total_price {
  width: 120px;
  height: 34px;
  line-height: 34px;
  text-indent: 10px;
  font-size: 16px;
}
.cartDetail {
  width: 100%;
  height: auto;
}
.cartItem {
  width: 90%;
  margin-left: 5%;
  position: relative;
}
.leftdot {
  position: absolute;
  width: 6px;
  height: 6px;
  left: -3.5%;
  top: 15px;
  background: linear-gradient(to right, #ffc914, #ffc813);
  border-radius: 50%;
}
.cart_dish {
  width: 100%;
}
.cart_dish_name {
  width: 80%;
  height: 50px;
  line-height: 50px;
  text-indent: 5px;
}
.cart_dish_icon {
  width: 80%;
  height: 40px;
  line-height: 40px;
}
.cart_dish_price {
  width: 20%;
  height: 35px;
  line-height: 35px;
  text-align: right;
  color: #aaa;
}
.cart_dish_des {
  width: 100%;
  height: 20px;
  line-height: 20px;
  font-size: 13px;
  color: #ccc;
}
.son_dish > .cart_dish_name {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
}
.son_dish > .cart_dish_price {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
}
.son_dish > .cart_dish_des {
  height: 18px;
  line-height: 18px;
  font-size: 12px;
}
.icon_group {
  padding-top: 10px;
  width: 100%;
  height: 35px;
  line-height: 35px;
  clear: both;
}
.realPrice {
  color: #000;
}
.detailBar {
  width: 100%;
  height: 35px;
  line-height: 35px;
  text-align: center;
  color: #222;
  background-color: #ffc914;
  border-bottom: 1px solid #f3f3f3;
  position: relative;
  /* padding-top: 46px; */
}
.rightIcon {
  position: absolute;
  right: 5px;
  top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/e_menu/Dishes.vue